import { createSelector } from 'reselect'

import { RootState } from 'redux/store'

const selectHighlight = createSelector(
  (state: RootState) => state.accordion.highlight,
  (highlight: string) => highlight
)

export default selectHighlight
